import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { IrbCommonModule } from "../irb-common/irb-common.module";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { TestComponent } from "./test/test.component";
import { FormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import { ComModelsComponent } from "./com-models/com-models.component";
import { ComClientsComponent } from "./com-clients/com-clients.component";
import { ComMmcComponent } from "./com-mmc/com-mmc.component";
import { ComRebalancingComponent } from "./com-rebalancing/com-rebalancing.component";
import { ComBlotterComponent } from "./com-blotter/com-blotter.component";
import { ComCashAnalysisComponent } from "./com-cash-analysis/com-cash-analysis.component";
import { ComAllocationComponent } from "./com-allocation/com-allocation.component";
import { ComDirectIndexingComponent } from "./com-direct-indexing/com-direct-indexing.component";
import { IrbAuthenticationGuard } from "@irb/irb-authentication/irb-authentication.guard";
import { IrbNavigationGuard } from "@irb-common/modules/main-menu/main-menu.navigation.guard";
import { IrbRouteAuthorizationAccessGuard } from "@irb-common/modules/main-menu/route-authorization-access.guard";
import { ComAutoRebalancingWidgetComponent } from './com-auto-rebalancing-widget/com-auto-rebalancing-widget.component';
import {
  ModuleAutoRebalancingWidgetComponent
} from "@irb/irb-dashboard/module-auto-rebalancing-widget/module-auto-rebalancing-widget.component";
import {ModuleAllocationComponent} from "@irb/irb-dashboard/module-allocation/module-allocation.component";
import {ModuleCashAnalysisComponent} from "@irb/irb-dashboard/module-cash-analysis/module-cash-analysis.component";
import {ModuleBlotterComponent} from "@irb/irb-dashboard/module-blotter/module-blotter.component";
import {ModuleRebalancingComponent} from "@irb/irb-dashboard/module-rebalancing/module-rebalancing.component";
import {ModuleMmcComponent} from "@irb/irb-dashboard/module-mmc/module-mmc.component";
import {ModuleClientsComponent} from "@irb/irb-dashboard/module-clients/module-clients.component";
import {ModuleModelsComponent} from "@irb/irb-dashboard/module-models/module-models.component";
import {ModuleDynamicBuilderComponent} from "@irb-common/components/module-dynamic-builder/module-dynamic-builder.component";
import {ButtonGroupModule} from "@charlesschwab/as-ui-core";
import { MatButtonToggle, MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  imports: [
    CommonModule,
    IrbCommonModule,
    RouterModule.forChild([
      {
        path: "home",
        component: DashboardComponent,
        canActivate: [IrbAuthenticationGuard, IrbRouteAuthorizationAccessGuard],
        canDeactivate: [IrbNavigationGuard],
      }
    ]),
    FormsModule,
    MatSelectModule,
    ButtonGroupModule,
    MatButtonToggle,
    MatButtonToggleModule,
    ModuleDynamicBuilderComponent
  ],
  declarations: [
    DashboardComponent,
    ComModelsComponent,
    ComClientsComponent,
    ComMmcComponent,
    ComRebalancingComponent,
    ComBlotterComponent,
    ComCashAnalysisComponent,
    ComAllocationComponent,
    TestComponent,
    ComDirectIndexingComponent,
    ComAutoRebalancingWidgetComponent,
    ModuleModelsComponent,
    ModuleClientsComponent,
    ModuleMmcComponent,
    ModuleRebalancingComponent,
    ModuleBlotterComponent,
    ModuleCashAnalysisComponent,
    ModuleAllocationComponent,
    ModuleAutoRebalancingWidgetComponent
  ],
  exports: [],
})
export class IrbDashboardModule {}
